export class Applicationcl {
  public IsProgressBarEnable!: Boolean;
  public FlushMessage!: string;
}
